import { SearchDevice } from './device/device.model';
import { SearchPlant } from './plant/plant.model';

export class Tag {
  constructor(public key?: string, public value?: string) {}
}

export class SearchCatalog {
  constructor(public plants?: SearchPlant[], public devices?: SearchDevice[]) {}
}

export class UpsSasToken {
  constructor(public sas?: string) {}
}

export enum AgendaCardType {
  NEWS = 0,
  ACADEMY = 1,
  EVENT = 2,
  MAINTENANCE = 3,
  MAINTENANCE_USER = 4,
}

export enum OccurrenceOptions {
  settings_one_day_before = '1',
  settings_two_days_before = '2',
  settings_one_week_before = '7',
  settings_two_weeks_before = '14',
  settings_one_month_before = '30',
  settings_two_months_before = '60',
}

export enum DateFormat {
  settings_date_it_IT = 'dd/MM/yyyy',
  settings_date_en_US = 'MM/dd/yyyy',
}
